import type { FloorPlanRoom } from '@kaiizen/kai-floor-plan';

/**
 * One row of the panel's room section. A length row's key is the panel
 * commit key its field writes through (`commitPanelFeet`); each platform
 * draws the rows with its own widgets.
 */
export type RoomSectionRow =
  | { key: 'level' }
  | { key: 'ceiling' | 'width' | 'length'; label: string; value: number }
  | { key: 'rotate' };

/**
 * The room section's rows, the same whether nothing is selected or the whole
 * room is: the room's level, its ceiling height, width and length, then the
 * quarter-turn rotate, which a read-only room leaves out.
 */
export const roomSectionRows = (room: FloorPlanRoom, readOnly: boolean): RoomSectionRow[] => [
  { key: 'level' },
  { key: 'ceiling', label: 'Ceiling height', value: room.height ?? 0 },
  { key: 'width', label: 'Width', value: room.width },
  { key: 'length', label: 'Length', value: room.length },
  ...(readOnly ? [] : [{ key: 'rotate' } as const]),
];
